/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";

import { useForm } from "react-hook-form";

import React from "react";
import { toast } from "react-toastify";
import { setupNotifications } from "@/services/notificationApi";
import { useAuth } from "@/context/AuthContext";
import { getUserDetails } from "@/services/userApi";
import { verifyMfa } from "@/services/authApi";

interface MfaFormInputs {
  otp: string;
  keepLogged: boolean;
}

const MfaVerify = () => {
  const navigate = useNavigate();
  const { user, getCurrentUser, fetchUser } = useAuth();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<MfaFormInputs>({
    defaultValues: {
      otp: "",
      keepLogged: false,
    },
  });

  const onSubmit = async (data: MfaFormInputs) => {
    try {
      const res = await verifyMfa(data.otp, data.keepLogged);
      console.log(res);
      // ✅ load user after MFA success
      await fetchUser(res["value"].id);
      // 🔔 IMPORTANT: setup notifications AFTER auth is complete
      await setupNotifications();

      navigate("/");
    } catch (err: any) {
      toast.error(
        <div>
          <strong>Verification Failed!</strong>
          <div style={{ fontSize: "0.9rem" }}>
            {err?.message || "Invalid code. Please try again."}
          </div>
        </div>,
      );
    }
  };

  return (
    <div className="signUp-admin-right signIn-admin-right">
      <div className="align-content-center h-100vh justify-content-center row">
        <div className="col-xl-7 col-lg-8 col-md-12">
          <div className="edit-profile mt-md-25 mt-0">
            <div className="card">
              <div className="card-header pb-md-15 pb-10 pt-md-20 pt-10">
                <div className="edit-profile__title">
                  <h6>Multi-Factor Authentication</h6>
                </div>
              </div>
              <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                  <div className="edit-profile__body">
                    {/* OTP Input */}
                    <div className="form-group mb-20">
                      <label htmlFor="otp-field">
                        Enter Authentication Code
                      </label>
                      <Input
                        className="form-control"
                        id="otp-field"
                        type="text"
                        placeholder="Enter 6-digit code"
                        maxLength={6}
                        {...register("otp", {
                          required: "Code is required",
                          minLength: {
                            value: 6,
                            message: "Code must be 6 digits",
                          },
                          maxLength: {
                            value: 6,
                            message: "Code must be 6 digits",
                          },
                        })}
                      />
                      {errors.otp && (
                        <small className="text-danger">
                          {errors.otp.message}
                        </small>
                      )}
                    </div>

                    {/* Keep me logged in */}
                    <div className="signUp-condition signIn-condition">
                      <div className="checkbox-theme-default custom-checkbox">
                        <input
                          className="checkbox"
                          type="checkbox"
                          id="check-1"
                          {...register("keepLogged")}
                        />
                        <label htmlFor="check-1">
                          <span className="checkbox-text">
                            Keep me logged in
                          </span>
                        </label>
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="button-group d-flex pt-1 justify-content-md-start justify-content-center">
                      <button
                        type="submit"
                        className="btn btn-primary btn-default btn-squared mr-15 text-capitalize lh-normal px-50 py-15 signIn-createBtn"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Verifying..." : "Verify"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MfaVerify;
